import { Statistic } from '../../services/sculkwire';
import { State as AppState } from '..';

export const selectStatistics = (state: AppState): Statistic[] => state.statistics;
